export function localStorageServices() {
    return {
        saveValueToLocalStorage: (key, value) => {
            localStorage.setItem(key.toString(), value.toString());
        },
        getValueFromLocalStorage: key => {
            return localStorage.getItem(key);
        },
        deleteValueFromLocalStorage: key => {
            localStorage.removeItem(key);
        }
    }
}
